import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setCredentials, logout } from '../../features/auth/authSlice'
import { baseUrl } from "../../config";

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseUrl}`,
  withCredentials: true,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) headers.set('authorization', `Bearer ${token}`);
    return headers;
  }
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)
  if (result?.error?.status === 401) {
    const refreshResult = await baseQuery({ url: '/Account/RefreshAccessToken', method: 'POST' }, api, extraOptions)
    if (refreshResult?.data?.data) {
      api.dispatch(setCredentials({ token: refreshResult.data }))
      result = await baseQuery(args, api, extraOptions)
    }
    else {
      api.dispatch(logout())
      window.location.reload();
    }
  }
  return result
}

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  endpoints: builder => ({})
})

